import { api } from "./api";

const basePath = "/permissions";
const pagesPath = "/permissions/pages";
const userPermissionPath = "/permissions/users";

export const permissionsService = {
  list(params) {
    return api.get(`${basePath}/`, { params });
  },

  getById(id) {
    return api.get(`${basePath}/${id}/`);
  },

  create(payload) {
    return api.post(`${basePath}/`, payload);
  },

  update(id, payload) {
    return api.patch(`${basePath}/${id}/`, payload);
  },

  remove(id) {
    return api.delete(`${basePath}/${id}/`);
  },

  listPages(params) {
    return api.get(`${pagesPath}/`, { params });
  },

  getPageById(id) {
    return api.get(`${pagesPath}/${id}/`);
  },

  listUserPermissions(params) {
    return api.get(`${userPermissionPath}/`, { params });
  },
};

export default permissionsService;
